import { render, staticRenderFns } from "./ActiveServiceCard.vue?vue&type=template&id=3a2ca9de&scoped=true&"
import script from "./ActiveServiceCard.vue?vue&type=script&lang=js&"
export * from "./ActiveServiceCard.vue?vue&type=script&lang=js&"
import style0 from "./ActiveServiceCard.vue?vue&type=style&index=0&id=3a2ca9de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2ca9de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VDivider,VIcon})
